/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uk_Email_Mp_TitleInputs */

const en_uk_email_mp_title = /** @type {(inputs: Uk_Email_Mp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Your MP`)
};

/**
* | output |
* | --- |
* | "Email Your MP" |
*
* @param {Uk_Email_Mp_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const uk_email_mp_title = /** @type {((inputs?: Uk_Email_Mp_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uk_Email_Mp_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_uk_email_mp_title(inputs)
});